
import AltaraP1 from '../Altara Prime/Altara Prime (1).webp'
import AltaraP2 from '../Altara Prime/Altara Prime (2).webp'
import AltaraP3 from '../Altara Prime/Altara Prime (3).webp'
import AltaraP4 from '../Altara Prime/Altara Prime (4).webp'
import AltaraP5 from '../Altara Prime/Altara Prime (5).webp'
import AltaraP6 from '../Altara Prime/Altara Prime (6).webp'
import AltaraP7 from '../Altara Prime/Altara Prime (7).webp'
import AltaraP8 from '../Altara Prime/Altara Prime (8).webp'
import AltaraP9 from '../Altara Prime/Altara Prime (9).webp'



const AltaraPimages =[
    AltaraP1,AltaraP2,AltaraP3,AltaraP4,AltaraP5,AltaraP6,AltaraP7,AltaraP8,AltaraP9
]

export default AltaraPimages;